/**
 * 
 * クロス商品設定マスタ管理画面の値を管理するクラス
 *
 * @export KYMW4800Model
 * @class KYMW4800Model
 */
export class KYMW4800Model {
  /**  バイヤーコードリスト */
  public buyerCodeList: Array<string> = [];
  /**  媒体一覧 */
  public mediumList: Array<any> = [];
  /**  媒体区分 */
  public mediumType: string = <string>'';
  /**  変更前媒体区分 */
  public beforeMediumType: string = <string>'';
  /** 画面表示用のクロス商品リスト */
  public crossGoodsList: Array<any> = [];
  /** API取得時のクロス商品リスト */
  public originalCrossGoodsList: Array<any> = [];
  /** 削除クロスコードリスト */
  public deleteCrossCodeList: Array<string> = [];
  /** クロス商品マップ */
  public crossGoodsMap = new Object();
  /** 表示要素数用リスト 掲載順Xを[ngForOf]で作成するために必要 */
  public displayList: Array<any> = [];
  /** 掲載順要素数リスト */
  public displayOrderLength = 0;
  /** 設定ボタン非活性フラグ */
  public isDisabledButtonSetting: boolean = true;
  /**
   * クロス商品一覧のデータ取得
   */
  public setBuyerCrossGoodsData(serverData: any): void {
    this.crossGoodsList = serverData;

    // 掲載順でソート
    for (const e of this.crossGoodsList) {
      e.CrossGoodsSetList.sort((a, b) => {
        return (Number(a.PublishSeq) < Number(b.PublishSeq) ? -1 : 1);
      })
    }

    this.originalCrossGoodsList = [...this.crossGoodsList]

    // グリッド表示用にマップで保持しリストの長さを揃える
    this.crossGoodsMap = new Object();
    this.displayList = [];
    this.displayOrderLength = 0;
    for (const e of this.crossGoodsList) {
      // チェックボックス表示バインド用にbool型に変換
      e.AutoDefaultSettings = e.AutoDefaultSettings === '1';

      this.crossGoodsMap[e.CrossCode] = e.CrossGoodsSetList;
      if (this.displayOrderLength < e.CrossGoodsSetList.length) {
        this.displayOrderLength = e.CrossGoodsSetList.length;
      }
      for (const ee of this.crossGoodsMap[e.CrossCode]) {
        // チェックボックス表示バインド用にbool型に変換
        ee.ChildKomaSettings = ee.ChildKomaSettings === '1';
      }
    }
    for (const key of Object.keys(this.crossGoodsMap)) {
      const len = this.crossGoodsMap[key].length
      if (len < this.displayOrderLength) {
        const missing = this.displayOrderLength - len;
        for (let i = 0; i < missing; i++) {
          // 商品数が最大値に満たないクロス設定に関しては、設定がない掲載順の商品情報をすべて「-」で表示する。
          this.crossGoodsMap[key].push({
            PCode: '-',
            GuideGoodsName: '-',
            GuideStandardName: '-',
            ChildKomaSettings: '-'
          })
        }
      }
    }
    for (let i = 0; i < this.displayOrderLength; i++) {
      this.displayList.push({});
    }
  }
}
